import { Box } from '@aviatrix/flights';
import React from 'react';

const GreyBox = (props:any)=>{
    return (
        <Box mt={1} sx={(theme) => ({
            borderRadius:2,
            bgcolor:'background.main',
            paddingTop:'10px',
            paddingBottom:'10px',
            paddingRight:'8px',
            paddingLeft:'8px',
            margin:0,
            textAlign:'center',
            ...props.sx
            })}>
                {props.children}
            </Box>
    )
}

export default GreyBox;